<div class="container mb-5" id="warranty">
  <div class="row">
    <div class="col-60 col-md-45 order-2 order-md-1">
      <h5 class="elsa-title-font warranty-title text-uppercase">{{'label_warranty_title' | translate}}</h5>
      <p class="product-description-header mt-5 font-weight-regular">
        {{'label_warranty_paragraph' | translate}}
      </p>
      <a title="Elsa" appEmptyTitle [href]="'warranty_page_url' | translate | safeUrl" target="_blank"
         class="btn btn-gray text-white btn-elsa text-uppercase">{{'label_warranty_button' | translate}}</a>
    </div>
    <div class="col-60 col-md-15 text-center order-1 order-md-2 mb-3 mb-md-0">
      <img alt="Elsa warranty logo" class="warranty-logo"
           src="https://media.elsasrl.com/storage/elsa-platform/media/be-xtra/warranty-logo.png">
    </div>
  </div>
</div>
